export const playerConverter = {
  // toFirestore: function(player) {
  //   return {
  //     name: player.name,
  //   }
  // },
  fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return {
      id: data.id,
      name: data.name,
      sex: data.sex,
      living_in_country: data.living_in_country,
      nationality: data.nationality,
      position_specific: data.position_specific,
      languages: data.languages,
      age: data.age,
      foot: data.foot,
      verband: data.verband,
      category: data.category,
      big_thumbnail: data.big_thumbnail,
      hasTeam: data.no_team,
      accountNotActivated: data.accountNotActivated,
    };
  },
};

export const trainerConverter = {
  fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return {
      id: data.id,
      name: data.name,
      sex: data.sex,
      living_in_country: data.living_in_country,
      trainer_type: data.trainer_type,
      nationality: data.nationality,
      license: data.license,
      languages: data.languages,
      age: data.age,
      verband: data.verband,
      category: data.category,
      big_thumbnail: data.big_thumbnail,
      hasTeam: data.no_team,
      accountNotActivated: data.accountNotActivated,
    };
  },
};

export const teamConverter = {
  fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return {
      id: data.id,
      team_name: data.team_name,
      nationality: data.nationality,
      playerprofile_position: data.playerprofile_position,
      trainerprofile_type: data.trainerprofile_type,
      verband: data.verband,
      category: data.category,
      big_thumbnail: data.big_thumbnail,
      accountNotActivated: data.accountNotActivated,
    };
  },
};

// export default {
//   teamConverter,
//   playerConverter,
//   trainerConverter,
// };
